import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import agentState from './agentState';
import artifactState from '~/artifact/reducer';
import expandableSectionState from './expandableSectionState';
import libraryState from '~/library/reducer';
import myState from './myState';
import navigationState from '~/sidebarNav/reducer';
import orgState from './orgState';
import orgFeatureFlagState from './orgFeatureFlagState';
import searchDataState from '~/search2/reducer'; //search2 state
import teamState from './teamState';
import popoverState from './popoverState';
import autosuggestFilterState from './autosuggestFilterState';
import vcPageState from './vcPageState';

const rootReducer = combineReducers({
  routing: routerReducer,
  agentState,
  artifactState,
  expandableSectionState,
  libraryState,
  myState,
  navigationState,
  orgState,
  orgFeatureFlagState,
  popoverState,
  autosuggestFilterState,
  searchDataState,
  teamState,
  vcPageState,
});

export default rootReducer;
